import type { MonitoramentoItem } from './models';

export type TipoAlerta = 'A' | 'B';

export const tipoAlertaDoItem = (item: Pick<MonitoramentoItem, 'slaStatus'>): TipoAlerta => (item.slaStatus === 'VERMELHO' ? 'B' : 'A');

export const emailValido = (email: string): boolean => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());

/** Texto padrão do alerta (o usuário pode editar tudo antes de enviar). */
export const alertaPadrao = (item: MonitoramentoItem, tipo: TipoAlerta) => {
  const horas = Math.abs(Math.round(item.horasRestantes));
  return {
    destinatarioNome: item.responsavel === '—' ? '' : item.responsavel,
    destinatarioEmail: item.responsavelEmail ?? '',
    assunto: tipo === 'A'
      ? `Nova Atividade Disponível para Aprovação — Concil. #${item.conciliacaoId} — ${item.empresa}`
      : `[URGENTE] Vencimento de Prazo (SLA) — Concil. #${item.conciliacaoId} — ${item.empresa}`,
    mensagem: tipo === 'A'
      ? `A conciliação #${item.conciliacaoId} referente a ${item.empresa} está disponível para sua análise na etapa ${item.etapa}.\nPrazo limite: ${item.dataLimite}.`
      : `A conciliação #${item.conciliacaoId} da empresa ${item.empresa} está VENCIDA há ${horas}h. Esta pendência requer atenção imediata para evitar escalonamento ao superior hierárquico e bloqueio preventivo de operações.`,
  };
};

/** Texto de horas restantes/vencidas sempre em números inteiros. */
export const textoHoras = (horas: number): string => {
  const h = Math.round(horas);
  return h >= 0 ? `${h}h restantes` : `Vencido há ${Math.abs(h)}h`;
};
